import { SVGProps } from 'react';

interface GlobalRefreshIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function GlobalRefreshIcon({
  className = '',
  ...props
}: GlobalRefreshIconProps) {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        opacity='0.4'
        d='M3.73003 15.7656C3.73003 15.7943 3.71094 15.8325 3.71094 15.8612C4.58974 17.6188 6.02256 19.0611 7.78017 19.9304C7.80883 19.9304 7.84704 19.9113 7.8757 19.9113C7.55092 18.8032 7.30256 17.6665 7.12106 16.5298C5.9748 16.3387 4.83809 16.0904 3.73003 15.7656Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M20.0072 7.93348C19.1093 6.05169 17.5905 4.53289 15.7183 3.64453C16.0621 4.78125 16.3487 5.94663 16.5398 7.112C17.7051 7.30304 18.8705 7.58004 20.0072 7.93348Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M14.9921 6.91065C14.7629 5.66886 14.4763 4.42708 14.0655 3.2235C14.0464 3.15664 14.0464 3.09933 14.0369 3.02291C13.33 2.85097 12.5849 2.73633 11.8208 2.73633C11.047 2.73633 10.3115 2.84142 9.59511 3.02291C9.58555 3.08978 9.59509 3.14708 9.57598 3.2235C9.17479 4.42708 8.87867 5.66886 8.64941 6.91065C10.7605 6.6814 12.8811 6.6814 14.9921 6.91065Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M6.9109 8.65039C5.65955 8.87964 4.42733 9.16621 3.22375 9.57696C3.15688 9.59606 3.09957 9.59606 3.02316 9.60561C2.85122 10.3125 2.73657 11.0576 2.73657 11.8217C2.73657 12.5955 2.84166 13.331 3.02316 14.0474C3.09002 14.057 3.14733 14.0474 3.22375 14.0665C4.42733 14.4677 5.65955 14.7638 6.9109 14.9931C6.68164 12.882 6.68164 10.7614 6.9109 8.65039Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M20.609 9.60561C20.5421 9.60561 20.4848 9.59606 20.4083 9.57696C19.2048 9.17576 17.963 8.87964 16.7212 8.65039C16.96 10.7614 16.96 12.882 16.7212 14.9835C17.963 14.7543 19.2048 14.4677 20.4083 14.057C20.4752 14.0379 20.5325 14.0474 20.609 14.0379C20.7809 13.3214 20.8955 12.5859 20.8955 11.8122C20.8955 11.0576 20.7905 10.322 20.609 9.60561Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M8.64941 16.7305C8.87867 17.9818 9.16524 19.214 9.57598 20.4176C9.59509 20.4845 9.58555 20.5418 9.59511 20.6182C10.3115 20.7901 11.047 20.9048 11.8208 20.9048C12.5849 20.9048 13.33 20.7997 14.0369 20.6182C14.0464 20.5513 14.0464 20.494 14.0655 20.4176C14.4667 19.214 14.7629 17.9818 14.9921 16.7305C13.9414 16.8451 12.8811 16.9311 11.8208 16.9311C10.7605 16.9215 9.70016 16.8451 8.64941 16.7305Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M8.42977 8.42977C8.1432 10.6841 8.1432 12.9575 8.42977 15.2214C10.6841 15.508 12.9575 15.508 15.2214 15.2214C15.508 12.9671 15.508 10.6936 15.2214 8.42977C12.9575 8.1432 10.6841 8.1432 8.42977 8.42977Z'
        fill='currentColor'
      />
      <path
        d='M23.4356 18.6015C22.6715 15.2965 17.6947 15.2869 16.9306 18.6015C16.4816 20.5406 17.7139 22.1836 18.7837 23.2057C19.567 23.9412 20.7992 23.9412 21.5825 23.2057C22.6524 22.1836 23.875 20.5406 23.4356 18.6015ZM20.2165 20.1299C19.6912 20.1299 19.2613 19.7 19.2613 19.1747C19.2613 18.6493 19.6816 18.2194 20.207 18.2194H20.2165C20.7515 18.2194 21.1718 18.6493 21.1718 19.1747C21.1718 19.7 20.7515 20.1299 20.2165 20.1299Z'
        fill='currentColor'
      />
      <path
        d='M6.9581 2.48239C6.19392 -0.822685 1.21721 -0.832238 0.453029 2.48239C0.00407368 4.42149 1.23631 6.06448 2.30616 7.08657C3.08945 7.82209 4.32169 7.82209 5.10497 7.08657C6.17482 6.06448 7.39751 4.42149 6.9581 2.48239ZM3.739 4.01075C3.21363 4.01075 2.78378 3.5809 2.78378 3.05552C2.78378 2.53015 3.20407 2.1003 3.72945 2.1003H3.739C4.27392 2.1003 4.69422 2.53015 4.69422 3.05552C4.69422 3.5809 4.27392 4.01075 3.739 4.01075Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M21.191 19.174C21.191 19.6993 20.7611 20.1292 20.2357 20.1292C19.7104 20.1292 19.2805 19.6993 19.2805 19.174C19.2805 18.6486 19.7008 18.2188 20.2262 18.2188H20.2357C20.7611 18.2188 21.191 18.6486 21.191 19.174Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M4.71318 3.05483C4.71318 3.58021 4.28333 4.01006 3.75796 4.01006C3.23259 4.01006 2.80273 3.58021 2.80273 3.05483C2.80273 2.52946 3.22303 2.09961 3.74841 2.09961H3.75796C4.28333 2.09961 4.71318 2.52946 4.71318 3.05483Z'
        fill='currentColor'
      />
    </svg>
  );
}
